import { useState, useEffect } from "react";
import { Agency, AgencyOfficialRole } from "../utils/types";
import { UserState } from "../hooks/useUser";
import { getAgency } from "./agenciesService";

export type AgencyOfficialRolesMap = Map<string, number>;

// would be great to have global state or lean on tanstack for something like this in the future.
const useAgencyData = (user: UserState | null) => {
  const [agencyData, setAgencyData] = useState<Agency | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [agencyOfficialRoles, setAgencyOfficialRoles] = useState<AgencyOfficialRolesMap>(new Map());

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    const fetchAgencyData = async () => {
      try {
        const { data, error } = await getAgency(user?.accessToken, user?.profile?.agency?.id);

        if (data) {
          setAgencyData(data);
        } else if (error) {
          setError(error);
        }
      } catch (error: any) {
        setError(error.message);
      }
      setLoading(false);
    };

    fetchAgencyData();
  }, [user]);

  const filterExcludedRoles = (roles: AgencyOfficialRole[]) => {
    const excludedRoles = ['Super Admin', 'Verification Specialist'];
    // these roles may eventually not come through from the backend, but for now and just in case:
    return roles.filter((role) => !excludedRoles.includes(role.name));
  };

  useEffect(() => {
    if (agencyData) {
      const filteredAgencyRoles = filterExcludedRoles(agencyData.roles || []);
      const byNameRoles = new Map(filteredAgencyRoles.map((role) => [role.name, role.id]));

      setAgencyOfficialRoles(byNameRoles);
    }
  }, [agencyData]);

  return { agencyOfficialRoles, error, setError, loading };
};

export default useAgencyData;